<template>
  <div id="step-notes">
    <div class="step-note">
      <label>Road Classification</label>
      <p :style="{ color: roadClassificationColor }">{{ roadClassification }}</p>
      <label>Road Accessibility</label>
      <ul>
        <li v-for="flag in accessFlags" :key="flag" :style="{ color: getFlagColor(flag) }">{{ flag }}</li>
      </ul>
      <label>Nearest Service Station</label>
      <p :style="{ color: serviceStationColor }">{{ serviceStation.result.name }} &middot; {{serviceStation.distance.toFixed(2)}} miles</p>
      <label>Nearest Fire Station</label>
      <p :style="{ color: fireStationColor }">{{ fireStation.result.name }} &middot; {{fireStation.distance.toFixed(2)}} miles</p>
      <label>Nearest Police Station</label>
      <p :style="{ color: policeStationColor }">{{ policeStation.result.name }} &middot; {{ policeStation.distance.toFixed(2) }} miles</p>
      <label>Nearest Alcohol Establishment</label>
      <p :style="{ color: alcoholEstColor }">{{ alcoholEst.result.name }} &middot; {{ alcoholEst.distance.toFixed(2) }} miles</p>
    </div>
  </div>
</template>

<script>
import chroma from 'chroma-js';

export default {
  data() {
    return { chroma }
  },
  computed: {
    accessFlags() {
      return this.step.road.Location.LinkInfo.AccessFlags;
    },
    roadClassification() {
      switch(this.step.road.Location.LinkInfo.FunctionalClass) {
        case 1:
          return 'High Volume, Maximum Speed';
        case 2:
          return 'High Volume, High Speed';
        case 3:
          return 'High Volume of Traffic Movement';
        case 4:
          return 'High Volume, Moderate Speed';
        case 5:
        default:
          return 'Unclassified or Low Volume and/or Movement';
      }
    },
    roadClassificationColor() {
      switch(this.step.road.Location.LinkInfo.FunctionalClass) {
        case 1:
        case 2:
          return chroma('red');
        case 3:
        case 4:
          return chroma('yellow').darken();
        case 5:
        default:
          return 'inherit';
      }
    },
    serviceStation() {
      return this.step.pointsOfInterest.gas;
    },
    serviceStationColor() {
      if(this.serviceStation.distance > 2) {
        return chroma('red');
      }
      if(this.serviceStation.distance > 1) {
        return chroma('yellow').darken();
      }
      return 'inherit';
    },
    fireStation() {
      return this.step.pointsOfInterest.fire;
    },
    fireStationColor() {
      if(this.fireStation.distance > 10) {
        return chroma('red');
      }
      if(this.fireStation.distance > 5) {
        return chroma('yellow').darken();
      }
      return 'inherit';
    },
    policeStation() {
      return this.step.pointsOfInterest.police;
    },
    policeStationColor() {
      if(this.policeStation.distance > 10) {
        return chroma('red');
      }
      if(this.policeStation.distance > 5) {
        return chroma('yellow').darken();
      }
      return 'inherit';
    },
    alcoholEst() {
      return this.step.pointsOfInterest.bar;
    },
    alcoholEstColor() {
      if(this.alcoholEst.distance < 1) {
        return chroma('red');
      }
      if(this.alcoholEst.distance < 2) {
        return chroma('yellow').darken();
      }
        return 'inherit';
    },
    step() {
      return this.$store.state.route.legs[0].steps[this.$store.state.stepIndex];
    },
  },
  methods: {
    getFlagColor(flag) {
      switch(flag) {
        case 'Deliveries':
        case 'Pedestrians':
        case 'Trucks':
        case 'Buses':
          return chroma('red');
        case 'Taxis':
        case 'Motorcycles':
        case 'ThroughTraffic':
        case 'EmergencyVehicle':
          return chroma('yellow').darken();
        default:
          return 'inherit';
      }
    }
  }
}
</script>

<style>
#step-notes {
  background: #fff;
  padding: 1rem;
  border-radius: 6px;
  width: 600px;
}

#step-notes .step-note label {
  font-weight: bold;
}
</style>
